import * as yup from "yup";
import i18n from "i18next";
import { INPUT_LENGTH } from "@duosoftbg/nacid-components";

export const createUsersFilterValidationSchema = () => {
  yup.setLocale({
    string: {
      matches: i18n.t("validation.field.invalid"),
    },
    mixed: {
      default: i18n.t("validation.field.invalid"),
    },
  });

  return yup.object().shape({
    name: yup.string().max(INPUT_LENGTH.MAX_INPUT_LENGTH_S, i18n.t("validation.name.charCount.invalid")),
  });
};
